import React from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarEnginePower,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';
import { MobileFilterWrapper } from '@/modules/CarsStock/components/common.styles';
import StockFilterRange from '@/components/StockFilterRange';

function EnginePowerFilter() {
  const dispatch = useTypedDispatch();
  const enginePower =
    useTypedSelector(getSelectedFilters).selectedParams.selectedEnginePower;

  const handleBlurEnginePower = (enginePower: RangeType) => {
    dispatch(setCarEnginePower(enginePower));
    dispatch(setPage(1));
  };

  return (
    <MobileFilterWrapper>
      <StockFilterRange
        label="Мощность двигателя, л.c"
        values={enginePower}
        onBlur={handleBlurEnginePower}
      />
    </MobileFilterWrapper>
  );
}

export default EnginePowerFilter;
